import { IpisFormElement } from "@eljouren/domain";
import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistMultipleChoiceInputBuilder from "./ChecklistMultipleChoiceInputBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
  question: IpisFormElement.MultipleChoiceType;
}

const ChecklistMultipleChoiceInputEditor = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistMultipleChoiceInputBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.editElement({ id: props.question.id, newValues: values });
        props.closeForm();
      }}
      defaultValues={props.question}
    />
  );
};

export default ChecklistMultipleChoiceInputEditor;
